<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div
          class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12"
          v-if="!clickedItem"
        >
          <v-btn class="btn-return" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12">
          <h3 class="title-pages pt-1">RESIDENTE: {{ resident.name }}</h3>
        </div>
      </div>
      <AnsweredForms
        v-on:clickedItem="handleDlickedItem"
        :resident_id="resident_id"
      />
    </div>
  </div>
</template>

<script>
import api from "../services/api";

import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import AnsweredForms from "../templates/Resident/Semiology/AnsweredForms";

import routes from "../routes";

export default {
  name: "AnsweredSemiologies",
  components: {
    NavBar,
    AuthBySessionExpired,
    AnsweredForms,
  },
  data() {
    return {
      resident_id: "",
      resident: {},
      loading: false,
      clickedItem: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    handleDlickedItem(clickedItem) {
      this.clickedItem = clickedItem;
    },
    async retrieve() {
      const { resident_id } = routes.history.current.params;
      this.resident_id = resident_id;

      await this.getResident();
    },
    async getResident() {
      try {
        this.loading = true;

        const { resident_id: id } = this;

        let params = { id };

        const response = await api.get("/rest-home/resident/name", {
          params,
        });

        const { resident, error } = response.data;

        if (error) {
          return routes.push({ name: "dashboard" });
        }

        if (!resident) {
          return routes.push({ name: "dashboard" });
        }

        this.resident = resident;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>
